import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "../../components/components.module";
import { WorkflowOldComponent } from "./workflow-old.component";
import { TableModule } from "primeng/table";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";
import { WorkflowEditOldComponent } from "./edit/workflow-edit-old.component";
import { ReactiveFormsModule } from "@angular/forms";
import { RippleModule } from "primeng/ripple";
import { DropdownModule } from "primeng/dropdown";
import { RouterLink } from "@angular/router";
import { TimelineModule } from "primeng/timeline";
import { CardModule } from "primeng/card";
import { TieredMenuModule } from "primeng/tieredmenu";
import { InputTextModule } from "primeng/inputtext";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { MenuModule } from "primeng/menu";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { ButtonModule } from "primeng/button";

const cmp = [WorkflowOldComponent, WorkflowEditOldComponent];
@NgModule({
    declarations: [...cmp],
    imports: [
        CommonModule,
        ComponentsModule,
        TableModule,
        ConfirmDialogModule,
        ToastModule,
        ReactiveFormsModule,
        RippleModule,
        DropdownModule,
        RouterLink,
        TimelineModule,
        CardModule,
        TieredMenuModule,
        InputTextModule,
        ConfirmPopupModule,
        MenuModule,
        DialogModule,
        TooltipModule,
        ButtonModule
    ],
    exports: [...cmp]
})
export class WorkflowOldModule {

}
